module.exports = __webpack_public_path__ + "images/icons_v2/menu-074d093a.svg";